/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: rF43GtStPO

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import ListItem from "../../components/ListItem"; // plasmic-import: v31d9_ANqk/component
import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_end_user_management.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicGroupItem.module.css"; // plasmic-import: rF43GtStPO/css

import EyeIcon from "../plasmic_kit/PlasmicIcon__Eye"; // plasmic-import: A2FnGYgDh4e3U/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon

createPlasmicElementProxy;

export type PlasmicGroupItem__VariantMembers = {
  withoutBorder: "withoutBorder";
};
export type PlasmicGroupItem__VariantsArgs = {
  withoutBorder?: SingleBooleanChoiceArg<"withoutBorder">;
};
type VariantPropType = keyof PlasmicGroupItem__VariantsArgs;
export const PlasmicGroupItem__VariantProps = new Array<VariantPropType>(
  "withoutBorder"
);

export type PlasmicGroupItem__ArgsType = { group?: React.ReactNode };
type ArgPropType = keyof PlasmicGroupItem__ArgsType;
export const PlasmicGroupItem__ArgProps = new Array<ArgPropType>("group");

export type PlasmicGroupItem__OverridesType = {
  root?: Flex__<"div">;
  listItem?: Flex__<typeof ListItem>;
  iconButton?: Flex__<typeof IconButton>;
};

export interface DefaultGroupItemProps {
  group?: React.ReactNode;
  withoutBorder?: SingleBooleanChoiceArg<"withoutBorder">;
  className?: string;
}

const $$ = {};

function PlasmicGroupItem__RenderFunc(props: {
  variants: PlasmicGroupItem__VariantsArgs;
  args: PlasmicGroupItem__ArgsType;
  overrides: PlasmicGroupItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "withoutBorder",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.withoutBorder,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_2dMe7XWUq916KsPnra5vYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootwithoutBorder]: hasVariant(
            $state,
            "withoutBorder",
            "withoutBorder"
          ),
        }
      )}
    >
      <ListItem
        data-plasmic-name={"listItem"}
        data-plasmic-override={overrides.listItem}
        actions={
          <IconButton
            data-plasmic-name={"iconButton"}
            data-plasmic-override={overrides.iconButton}
            children2={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__plrDw)}
                role={"img"}
              />
            }
            className={classNames("__wab_instance", sty.iconButton)}
            size={"vertical"}
            type={["seamless"]}
          >
            <EyeIcon
              className={classNames("all", sty.svg__j2HoQ)}
              role={"img"}
            />
          </IconButton>
        }
        className={classNames("__wab_instance", sty.listItem, {
          [sty.listItemwithoutBorder]: hasVariant(
            $state,
            "withoutBorder",
            "withoutBorder"
          ),
        })}
        hasMenu={true}
        hideIcon={true}
      >
        {renderPlasmicSlot({
          defaultContents: "mgmt",
          value: args.group,
          className: classNames(sty.slotTargetGroup),
        })}
      </ListItem>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "listItem", "iconButton"],
  listItem: ["listItem", "iconButton"],
  iconButton: ["iconButton"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  listItem: typeof ListItem;
  iconButton: typeof IconButton;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicGroupItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicGroupItem__VariantsArgs;
    args?: PlasmicGroupItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicGroupItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicGroupItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicGroupItem__ArgProps,
          internalVariantPropNames: PlasmicGroupItem__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicGroupItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicGroupItem";
  } else {
    func.displayName = `PlasmicGroupItem.${nodeName}`;
  }
  return func;
}

export const PlasmicGroupItem = Object.assign(
  // Top-level PlasmicGroupItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    listItem: makeNodeComponent("listItem"),
    iconButton: makeNodeComponent("iconButton"),

    // Metadata about props expected for PlasmicGroupItem
    internalVariantProps: PlasmicGroupItem__VariantProps,
    internalArgProps: PlasmicGroupItem__ArgProps,
  }
);

export default PlasmicGroupItem;
/* prettier-ignore-end */
